

const currentLocation = () => window.location.pathname;

const updateLocation = path =>  {
    if (window.location.pathname !== path)
        window.history.pushState({},"",path);
};

const onLocationChange = f => {
    window.onpopstate = () => {
        f(window.location.pathname);
    };
};

export {
    updateLocation,
    onLocationChange,
    currentLocation
 };





// WEBPACK FOOTER //
// ./src/navigation/location.js